import { useContext, useEffect } from "react";
import { Context } from "../../../../context";
import { Layout } from "../../../../containers/layout/dashboard";
import { SMSBalanceWrapper } from "./styled";

export const SMSBalance = () => {
    const { setActiveNavItem } = useContext(Context);

    useEffect(() => {
        setActiveNavItem("Accounting");
    }, [setActiveNavItem]);

    return (
        <Layout
            id="sms-balance"
        >
            <SMSBalanceWrapper>

            </SMSBalanceWrapper>
        </Layout>
    )
}